import * as classnames from 'classnames'
import * as React from 'react'
import { compose, pure } from 'recompose'

import { QuestionType, QuizType } from '../../../../commons/EditorStatus'
import * as QuizPhase from '../../../../commons/QuizPhase'
import HighlightText from '../../molecules/HighlightText/HighlightText'
import * as styles from './PresentationControllerStatus.css'

export enum DirectionType {
  vertical,
  horizontal
}

interface PresentationControllerStatusProps {
  type: number
  questionType: number
  highlightedIndex?: number
  rankingCount: number
  directionType: DirectionType
}

const PresentationControllerStatus: React.FunctionComponent<PresentationControllerStatusProps> = ({
  type,
  questionType = null,
  highlightedIndex,
  rankingCount,
  directionType
}) => {
  let itemList: string[] = []
  switch (type) {
    case QuizType.NOTIFICATION.value:
      itemList = ['注意書き']
      break
    case QuizType.FIRSTPAGE.value:
      itemList = ['QRコード']
      break
    case QuizType.QUESTION.value:
      itemList = questionType === QuestionType.REALTIME.value ? QuizPhase.FLOW_LIST_REALTIME : QuizPhase.FLOW_LIST
      break
    case QuizType.RANKING.value:
      itemList = ['結果発表']
      itemList.push(
        ...[...Array(rankingCount)]
          .fill(null)
          .map((_, i) => `第${i + 1}位`)
          .reverse()
      )
      break
    case QuizType.COMPLETE.value:
      itemList = ['クイズが終了しました。このページを閉じても他のページに影響はありません。']
      break
  }
  const content = itemList.map((item, index) => (
    <div
      key={`controller-phase-${index}`}
      className={classnames(styles.item, QuizType.RANKING.value === type ? styles.ranking : null)}
    >
      <HighlightText isHighlighted={index === highlightedIndex}>{item}</HighlightText>
    </div>
  ))

  const TEXT_WIDTH_WITH_MARGIN = 60 + 24
  const TEXT_HEIGHT_WITH_MARGIN = 34 + 8

  const isVertical = directionType === DirectionType.vertical
  const textWithMargin = isVertical ? TEXT_HEIGHT_WITH_MARGIN : TEXT_WIDTH_WITH_MARGIN
  const position = QuizType.RANKING.value === type ? (highlightedIndex || 0) * textWithMargin : 0
  const transform = isVertical ? `translateY(-${position}px)` : `translateX(-${position}px)`
  return (
    <div className={styles.container}>
      <div className={styles.itemList} style={{ transform }}>
        {content}
      </div>
    </div>
  )
}

export default compose<PresentationControllerStatusProps, PresentationControllerStatusProps>(pure)(
  PresentationControllerStatus
)
